import {Map as IMap} from 'immutable';
import {weakMemo} from '@packages/utilities/memo';

import {TypeImplementation} from '@packages/systems/wfdl';
import {
  COLLECTION_LIST_PROPS,
  getCollectionListPropTypeNameString,
} from '@packages/systems/dynamo/utils/CollectionListPropNameUtils';
import {createCollectionListType} from '@packages/systems/dynamo/utils/CollectionListPropsUtils';

export const getCollectionIds = weakMemo(
  (collections: IMap<string, unknown>): readonly string[] =>
    collections.keySeq().toArray()
);

export const makeCollectionListPropTypes = weakMemo(
  (
    collectionIds: ReadonlyArray<string> | ReadonlySet<string>
  ): Record<string, TypeImplementation.TypeImplementation> => {
    const acc: Record<string, TypeImplementation.TypeImplementation> = {};
    for (const collectionId of collectionIds) {
      for (const propKind of Object.values(COLLECTION_LIST_PROPS)) {
        acc[getCollectionListPropTypeNameString(propKind, collectionId)] =
          createCollectionListType(propKind, collectionId);
      }
    }
    return acc;
  }
);
